module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//8_Diamond.png?v=7595d18b";